import { getChannelAPIPath } from '@treasury/core/http';

StatesService.$inject = ['$resource', '$q'];

export default function StatesService($resource, $q) {
    return {
        getAll,
    };

    function getAll() {
        return $resource(`${getChannelAPIPath()}states/`).query().$promise;
    }
}
